import countries from '../json/countries.json';
import { DOM } from '../helpers/DOM.js';
export class PhoneNumberField {
	#phoneCodesOptions = {};

	constructor() {
		setTimeout( () => {
			this.#initPhoneCodes();
		}, 1 );
	}
	#initPhoneCodes() {
		const selects = document.querySelectorAll( '.country-phone-codes' );

		if ( ! selects ) {
			return;
		}

		for ( const select of selects ) {
			const codeField = DOM.el( '.country-phone-code-input', select );

			let selectedValue =
				localStorage.getItem( 'levcharity_user_country_code' ) || 'US';

			if ( codeField?.value ) {
				const value = '+' + codeField.value.replace( /\+|(\s+)/g, '' );
				selectedValue =
					countries.find(
						( country ) => value === country?.dial_code
					)?.code || selectedValue;
			}

			this.#loadPhoneCodes( select, selectedValue, '', true, true, codeField?.id || codeField.name );
		}

		DOM.addEvent( 'click', '.country-phone-codes', ( event, select ) => {
			event.preventDefault();
			const value = select.querySelector( '.value' );
			const input = select.querySelector( '.country-phone-code-input' );
			const item = event.target.matches( '.dropdown .item' )
				? event.target
				: event.target.closest( '.dropdown .item' );

			if ( ! select.classList.contains( 'is-open' ) ) {
				select.classList.add( 'is-open' );
				setTimeout( () => {
					select
						.querySelector( '.search-country-dial-code' )
						?.focus();
				}, 10 );
			} else if ( item && ! item.classList.contains( 'current' ) ) {
				select.classList.remove( 'is-open' );

				value.innerHTML = item.outerHTML;
				input.value = item?.dataset?.value || '';

				select.dataset.current = item.dataset.code ?? '';

				this?.onChange( item, select, input, value );
			}

			if ( item ) {
				item.classList.add( 'current' );
			}

			select
				.querySelectorAll( '.dropdown .item.current' )
				?.forEach( ( el ) => {
					if ( item && el !== item ) {
						el.classList.remove( 'current' );
					}
				} );
		} );

		DOM.addEvent( 'click', document, ( event, doc ) => {
			if ( event.target.matches( '.country-phone-codes *' ) ) {
				return;
			}

			if ( document.querySelectorAll( '.country-phone-codes.is-open' ) ) {
				document
					.querySelectorAll( '.country-phone-codes.is-open' )
					.forEach( ( el ) => {
						el.classList.remove( 'is-open' );
					} );
			}
		} );

		DOM.observeElements(
			'.country-phone-codes .item img.country-flag',
			( image ) => {
				if ( image?.dataset?.src ) {
					image.src = image.dataset.src;
					image.removeAttribute( 'data-src' );
				}
			}
		);

		DOM.addEvent(
			'input',
			'.search-country-dial-code',
			( event, field ) => {
				const select = field.closest( '.country-phone-codes' );
				const codeField = DOM.el( '.country-phone-code-input', select );
				this.#loadPhoneCodes( select, null, field.value, false, false, codeField?.id || codeField.name);
			}
		);
	}

	#loadPhoneCodes(select, selectedValue = null, searchValue = null, lazy = true, firstTime = false, id = '') {
		const api_url = 'https://flagcdn.com/w40/';

		const emptySrc =
			'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAQSURBVHgBAQUA+v8AAAAAAAAFAAFkeJU4AAAAAElFTkSuQmCC';

		let value = null;
		let inputValue = '';
		const list = select.querySelector( '.dropdown .list' );
		list.innerHTML = '';

		const sortedCountries = [ ...countries ];
		if ( searchValue ) {
			sortedCountries.sort( ( a, b ) => {
				if (
					this.#countryInResults( a, searchValue ) ||
					this.#countryInResults( b, searchValue )
				) {
					if ( a.code.toLowerCase() === searchValue.toLowerCase() ) {
						return 1;
					}
					if ( b.code.toLowerCase() === searchValue.toLowerCase() ) {
						return -1;
					}

					const nameComparison = a.name.localeCompare( b.name );
					if ( nameComparison !== 0 ) {
						return -1 * nameComparison;
					}

					const dialCodeA = parseInt(
						a.dial_code.replace( '+', '' ),
						10
					);
					const dialCodeB = parseInt(
						b.dial_code.replace( '+', '' ),
						10
					);
					return dialCodeA - dialCodeB;
				}
				return this.#countryInResults( b, searchValue ) ? 1 : -1;
			} );
		}

		for ( const country of sortedCountries ) {
			const code = country.dial_code;
			const countryCode = country.code;
			const name = country.name;

			if ( countryCode === 'PS' ) {
				continue;
			}

			let hide = false;

			if ( searchValue ) {
				if ( ! this.#countryInResults( country, searchValue ) ) {
					hide = true;
				}
			}

			let option =
				[].filter.call( this.#phoneCodesOptions[id] || [], function ( element ) {
					return element.matches( `.country-${ countryCode }` );
				} )[ 0 ] || null;

			if ( ! option ) {
				option = document.createElement( 'div' );
				option.className = `item${
					! value && countryCode === selectedValue ? ' current' : ''
				} country-${ countryCode }`;
				option.dataset.value = code.replace( '+', '' );
				option.dataset.code = countryCode;
				option.innerHTML = `<img class="country-flag" ${
					lazy ? `src="${ emptySrc }" data-` : ''
				}src="${ api_url }${ countryCode.toLowerCase() }.png" title="${ countryCode }"/><span class="code">${ code }</span><span class="name">${ name }</span>`;
			}

			if ( firstTime && countryCode === selectedValue ) {
				this?.onInit( option, select, selectedValue );
			}

			if ( hide ) {
				option.style.display = 'none';
			} else {
				option.style.display = '';
			}

			if ( countryCode === select?.dataset?.current ) {
				option.classList.add( 'current' );
			} else if (
				option.classList.contains( 'current' ) &&
				countryCode !== selectedValue
			) {
				option.classList.remove( 'current' );
			}

			if ( hide || ! searchValue ) {
				list.append( option );
			} else {
				list.prepend( option );
			}

			if ( selectedValue ) {
				if ( ! value && countryCode === selectedValue ) {
					inputValue = code.replace( '+', '' );
					value = option.cloneNode( true );
					value.classList.remove();
				}
			}
		}

		if ( selectedValue ) {
			select.querySelector( '.country-phone-code-input' ).value =
				inputValue;
			select.querySelector( '.value' ).innerHTML = '';
			select.querySelector( '.value' ).append( value );
			select.dataset.current = selectedValue;
		}

		if ( ! searchValue ) {
			this.#phoneCodesOptions[id] = [ ...list.children ];
		}
	}

	#countryInResults( country, searchValue ) {
		const searchArray = [
			country.code,
			country.name,
			country.capital,
			country.dial_code,
			country.emoji,
			country.unicode,
			...country.timezones,
		];

		return searchArray.some( ( value ) => {
			if ( ! value ) {
				return false;
			}

			const v = value
				.toLowerCase()
				.trim()
				.split( /[\s_\\\/]+/ )
				.join( '-' );
			const s = searchValue
				.toLowerCase()
				.trim()
				.split( /[\s_\\\/]+/ )
				.join( '-' );

			return (
				value === searchValue ||
				v === s ||
				v.startsWith( s ) ||
				v.includes( s )
			);
		} );
	}

	onChange() {}

	onInit() {}
}
